const sliderLinks = [
  {
    "id": 1,
    "title": "Plan Estatal de Desarrollo",
    "description": "El Gobierno del Estado de Hidalgo a través de la Unidad de Planeación y Prospectiva impulsa la Actualización del Plan Estatal de Desarrollo con una visión que responde a las transformaciones alcanzadas en nuestra entidad, así como los nuevos retos y oportunidades, además de las prioridades planteadas en el Plan Nacional de Desarrollo 2025-2030.",
    "image": ".../../assets/imgs/Apps/planestatal.png",
    // "linkInt": "https://bancodeproyectos.hidalgo.gob.mx/" 
    "linkExt": "https://planestataldedesarrollo.hidalgo.gob.mx/"
    
  },
  {
    "id": 2,
    "title": "Banco de Proyectos ",
    "description": "Integra iniciativas, organiza expedientes y vincula proyectos con territorios, instituciones y resultados para fortalecer la inversión pública en Hidalgo.",
    "image": ".../../assets/imgs/Apps/bp.png",
    // "linkInt": "https://bancodeproyectos.hidalgo.gob.mx/" 
    "linkExt": "https://bancodeproyectos.hidalgo.gob.mx/"
   
  },
  {
    "id": 3,
    "title": "Banco de Buenas prácticas ",
    "description": "Plataforma que se utiliza como repositorio de buenas prácticas municipales, identifica y documenta acciones gubernamtales que atienden problemas públicos.",
    "image": ".../../assets/imgs/Apps/buenaspracticas.png",
    // "linkInt": "https://bancodeproyectos.hidalgo.gob.mx/" 
    "linkExt": "https://buenaspracticas.hidalgo.gob.mx/"
   
  },
  {
    "id": 4,
    "title": "Metropoli",
    "description": "Es una herramienta digital integral diseñada para dar seguimiento, consultar y transparentar la gestión y avances en materia de planeación y coordinación metropolitana.",
    "image": ".../../assets/imgs/Apps/metropoli.png",
    // "linkInt": "https://bancodeproyectos.hidalgo.gob.mx/" 
    "linkExt": "https://metropoli.hidalgo.gob.mx/"
   
  },
  {
    "id": 5,
    "title": "Biblioteca Digital de Planeación",
    "description": "Herramienta pública para el almacenamiento y consulta de documentos, programas, planes, informes, estudios, artículos, guías y demás instrumentos.",
    "image": ".../../assets/imgs/Apps/biblioteca.png",
    "linkExt": "https://bibliotecadigitaluplaph.hidalgo.gob.mx/" 
  },
  {
    "id": 6,
    "title": "Laboratorio Estatal de Políticas Públicas",
    "description": "Datos y análisis estratégicos para impulsar las decisiones públicas basadas en evidencia científica.",
    "image": ".../../assets/imgs/Apps/laboratorio.png",
    "linkExt": "https://labpoliticas.hidalgo.gob.mx/" 
  },
  {
    "id": 7,
    "title": "Plataforma Pública de Indicadores de Hidalgo",
    "description": "El portal TECI permite consultar el desempeño institucional mediante indicadores validados técnicamente para garantizar la calidad de la información.",
    "image": ".../../assets/imgs/Apps/indicadores.png",
    "linkExt": "https://indicadores.hidalgo.gob.mx/" 
  }
];

export default sliderLinks;